import AmpleHireImageTag from "../ample-hire-html-tags/ample-hire-image-tag";
import { image } from "../assets/assets";

const InterviewFooter = () => {
  return (
    <footer className="int-main-footer">
      <div className="container">
        <div className="footer-right right">
          <span style={{ fontSize: "12px", color: "var(--text-muted)", fontWeight: "500" }}>Powered by</span>
          <a href="#" className="logo-main">
            <AmpleHireImageTag
              imgSrc={image.brandStrategicPartnerLogo}
              altText="brand-logo"
            />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default InterviewFooter;
